import { ConnectionStatus, IntegrationMarketingResponse } from '@vendasta/platform-integrations';
import { AppSettings } from '@vendasta/marketplace-apps/lib/_internal/objects/app-settings';
import { User } from '@vendasta/iamv2';

// Single Connection tied to Single Integration
export declare class ConnectionIntegrationDetail {
  connectionId: string;
  namespace: string;
  integrationId: string;
  integration: IntegrationMarketingResponse;
  userId: string;
  userInfo: User;
  status: ConnectionStatus;
  label: string;
  created: Date;
  updated: Date;
  deleted: Date;
}
export declare class CustomField {
  label: string;
  value: string;
}

export enum ServiceType {
  SelfServeUpgrade = 'Self-serve upgrade',
  ContactSalesperson = 'Contact a salesperson',
  UpgradeToPro = 'Upgrade to Pro with a custom package',
}

export interface RmAppDetail {
  hasRMPremiumActive: boolean;
  upgradeSetting: AppSettings;
  namespace?: string;
  partnerId?: string;
}

export enum IntegrationType {
  QUICKBOOKS = 'QuickBooks',
  ZAPIER = 'Zapier',
  APPLEBUSINESSCONNECT = 'AppleBusinessConnect',
  PROTRACTOR = 'Protractor',

  // Legacy IntegrationTypes
  GOOGLEMYBUSINESS = 'GoogleMyBusiness',
  FACEBOOK = 'Facebook',
  GOOGLESEARCHCONSOLE = 'GoogleSearchConsole',
  GOOGLEANALYTICS = 'GoogleAnalytics',
  GOOGLEMEET = 'GoogleMeet',
  ZOOMMEET = 'ZoomMeet',
  QUICKBOOKSONLINEPERSONAL = 'QuickBooksOnlinePersonal',
  INSTAGRAM = 'Instagram',
}

export interface VAPIResponse {
  data: any;
  requestId: string;
  responseTime: number;
  statusCode: number;
  version: string;
}
